import React, { createContext, useContext, useState, useCallback } from 'react';

const AskAnalystContext = createContext(null);

export const AskAnalystProvider = ({ children }) => {
  const [panelState, setPanelState] = useState('closed');
  const [context, setContextState] = useState({
    region: 'GLOBAL',
    quarter: 'Q4FY26',
    activeTab: 'dashboard',
  });

  const setContext = useCallback((partial) => {
    setContextState((prev) => ({ ...prev, ...partial }));
  }, []);

  const openPanel = useCallback(() => setPanelState('open'), []);
  const minimizePanel = useCallback(() => setPanelState('minimized'), []);
  const expandPanel = useCallback(() => setPanelState('open'), []);
  const closePanel = useCallback(() => setPanelState('closed'), []);
  const togglePanel = useCallback(
    () => setPanelState((s) => (s === 'open' ? 'closed' : 'open')),
    []
  );

  const isOpen = panelState !== 'closed';
  const isMinimized = panelState === 'minimized';

  return (
    <AskAnalystContext.Provider
      value={{
        panelState,
        isOpen,
        isMinimized,
        openPanel,
        minimizePanel,
        expandPanel,
        closePanel,
        togglePanel,
        context,
        setContext,
      }}
    >
      {children}
    </AskAnalystContext.Provider>
  );
};

export const useAskAnalyst = () => {
  const ctx = useContext(AskAnalystContext);
  if (!ctx) throw new Error('useAskAnalyst must be used within AskAnalystProvider');
  return ctx;
};
